module.exports = __webpack_public_path__ + "static/img/yingshiCamera.49724c34.png";